import { createContext } from "react";

type SearchTabContextType = {
  searchTab: number;
  setSearchTab: React.Dispatch<React.SetStateAction<number>>;
  docSearchKey: number;
  setDocSearchKey: React.Dispatch<React.SetStateAction<number>>;
  userSearchKey: number;
  setUserSearchKey: React.Dispatch<React.SetStateAction<number>>;
  orgSearchKey: number;
  setOrgSearchKey: React.Dispatch<React.SetStateAction<number>>;
};

type SearchResultsAccordionCollapsedContextType = {
  searchResultsAccordionCollapsed: { [key: string]: boolean };
  setSearchResultsAccordionCollapsed: React.Dispatch<
    React.SetStateAction<{ [key: string]: boolean }>
  >;
};

export const SearchTabContext = createContext({
  searchTab: 0,
} as SearchTabContextType);

export const SearchResultsAccordionCollapsedContext = createContext({
  searchResultsAccordionCollapsed: {},
} as SearchResultsAccordionCollapsedContextType);
